module.exports = __webpack_public_path__ + "img/hr-lamp.b4f4f278.png";